import "@theme/klaviyo-back-in-stock";
import { ViewedProduct } from "@theme/viewed-product";
import { Recommendations } from "@theme/recommendations";
import "@theme/lightbox";
import ProductFormHandler from "@theme/product-form-handler";

// new ViewedProduct();
new Recommendations();

/**
 * FG product form (`snippets/fg-product-form`): pack size radios, OTP vs subscribe,
 * selling_plan select enable/disable — needs ProductFormHandler. Runs after <product-form> is defined.
 */
function initProductFormHandler() {
  const host = document.querySelector("product-form");
  if (!host?.querySelector?.(".purchase-type-radio")) {
    return;
  }
  if (host.dataset.productFormHandlerInit === "true") {
    return;
  }
  host.dataset.productFormHandlerInit = "true";
  new ProductFormHandler(host);
}

if (customElements.get("product-form")) {
  queueMicrotask(initProductFormHandler);
} else {
  customElements.whenDefined("product-form").then(initProductFormHandler);
}

/**
 * Feeding Advice trigger tab: keep it hidden over the top of the PDP and reveal it
 * once the user has scrolled past the product form (#main-product). The hidden/visible
 * states live in CSS (feeding-advice-modal.liquid); here we just toggle the class.
 */
function initFmfScrollTrigger() {
  const modal = document.querySelector(".fmf-modal:not(.fmf-page-embed)");
  const mainProduct = document.querySelector(".main-product");
  if (!modal || !mainProduct) return;

  const update = () => {
    const rect = mainProduct.getBoundingClientRect();
    modal.classList.toggle("fmf-trigger-revealed", rect.bottom < 0);
  };

  update();
  window.addEventListener("scroll", update, { passive: true });
}

initFmfScrollTrigger();
